import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class MadCapPageHeaderSchemaPlugin extends SchemaPlugin {
  nodes = {
    madcappageheader: {
      group: 'block',
      content: 'block+',
      defining: true, // Persist and wrap the inserted content during replace operations
      fillIfContentDeleted: 'mcCentralContainer',
      parseDOM: [{
        tag: 'MadCap\\:pageHeader'
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:pageHeader'
    }
  } satisfies Record<string, NodeSpec>;
}
